import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';

class SendWord extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            offSet: 0,
        };
    }
    moveToPre = () => {
        const oldOffSet = this.state.offSet;

        if (oldOffSet < 0) {
            let currentOffSet = '';

            this.timer = setInterval(() => {
                currentOffSet = this.state.offSet;
                if (currentOffSet - oldOffSet === 790) {
                    clearInterval(this.timer);
                }
                this.setState({
                    offSet: currentOffSet + 10,
                });
            }, 5);
        }
    };
    moveToNext = () => {
        const oldOffSet = this.state.offSet;

        if (oldOffSet > -800) {
            let currentOffSet = '';

            this.timer = setInterval(() => {
                currentOffSet = this.state.offSet;
                if (oldOffSet - currentOffSet === 790) {
                    clearInterval(this.timer);
                }
                this.setState({
                    offSet: currentOffSet - 10,
                });
            }, 5);
        }
    };
    /**
     * 渲染网页布局
     */
    render() {
        const { content } = this.props;

        const swiperList = content.map((currentSwiper, index) => {
            return (
                <li className={styles.slide} key={index}>
                    <div className={styles.portrait}>
                        <img src={currentSwiper.headPic} />
                        <pre>{currentSwiper.name}</pre>
                    </div>
                    <p>{currentSwiper.word}</p>
                </li>
            );
        });

        return (
            <div className={styles.sendWord} id="members">
                <h3>嘉宾寄语</h3>
                <div className={styles.swiperBox}>
                    <div className={styles.preBtn} onClick={this.moveToPre} />
                    <div className={styles.nextBtn} onClick={this.moveToNext} />
                    <div className={styles.swiper_main}>
                        <ul className={styles.swiper_wrapper} style={{ left: `${this.state.offSet}px` }}>
                            {swiperList}
                        </ul>
                    </div>
                </div>
            </div>
        );
    }
}

/**
 * 定义组件属性类型
 * 类型以及是否需要
 * */
SendWord.propTypes = { content: PropTypes.array };

/**
 * 定义组件默认属性
 * */
SendWord.defaultProps = {};

export default SendWord;
